<app-header></app-header>
<app-side-bar>
  <router-outlet></router-outlet>
</app-side-bar>
<upload-card  *ngIf="isVisible"></upload-card>
